<template>
	<div class="item4">
		<img class="logoico" src="../assets/images/logo.png" />
		<back></back>
		<div class="item4box">
			<div class="title">
				<div>典故篇</div>
				<p>
					<img src="../assets/images/dgptitlebag.png" />
					<span>“药王”孙思邈的故事</span>
				</p>
			</div>
			<div class="content">
				<div><a href="javascript:void(0);" @click="inbase(1)"><img src="../assets/images/dgitem1.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(2)"><img src="../assets/images/dgitem2.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(3)"><img src="../assets/images/dgitem3.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(4)"><img src="../assets/images/dgitem4.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(5)"><img src="../assets/images/dgitem5.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(6)"><img src="../assets/images/dgitem6.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(7)"><img src="../assets/images/dgitem7.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(8)"><img src="../assets/images/dgitem8.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(9)"><img src="../assets/images/dgitem9.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(10)"><img src="../assets/images/dgitem10.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(11)"><img src="../assets/images/dgitem11.png" /></a></div>
				<div><a href="javascript:void(0);" @click="inbase(12)"><img src="../assets/images/dgitem12.png" /></a></div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	import axios from 'axios'
	export default {
		components: {
			back
		},
		data() {
			return {
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				videoisshow: false,
				videotitle: '',
				videolist: []
			}
		},
		created() {

		},
		methods: {
			inbase(id){
				this.$router.push({
					path:'/item4base',
					query:{
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.item4 {
		background: url(../assets/images/item5bag.jpg) no-repeat;
		background-size: 120% auto;
		background-position: left center;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
	}
	.item4 .title p{
		height: 2.5rem;
		text-align: center;
		position: relative;
		color: #9b6951;
		margin-top: 1rem;
	}
	.item4 .title p img{
		width: calc(6rem * 6.39);
		height: 2.5rem;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
	}
	.item4 .title p span{
		line-height: 2.5rem;
		display: inline-block;
		font-size: 1rem;
	}
	.item4 .item4box {
		position: absolute;
		z-index: 3;
		left: 1rem;
		top: 8rem;
		right: 1rem;
		bottom: 1rem;
		text-align: center;
	}

	.item4 .logoico {
		position: absolute;
		top: 3rem;
		left: 3rem;
		width: 18rem;
	}

	.item4 .title {
		text-align: center;
	}

	.item4 .title div {
		line-height: 6rem;
		width: calc(6rem * 6.39);
		height: 6rem;
		margin: 0px auto;
		background: url(../assets/images/itemtitlebag.png) no-repeat;
		background-size: 100%;
		font-family: 'STXingkai';
		font-size: 3rem;
		color: #FFFFFF;
	}
	.item4 .content{
		width: 80rem;
		height: 48rem;
		display: flex;
		flex-wrap: wrap;
		margin: 0px auto;
		text-align: center;
		overflow-y: auto;
	}
	.item4 .content div{
		width: calc(100% / 4);
		height: calc(48rem / 3);
		position: relative;
	}
	.item4 .content div a{
		position: absolute;
		width: 11rem;
		height: auto;
		margin: auto;
		left: 0;
		right: 0;
		top: 3rem;
		bottom: 0;
	}
	.item4 .content div img{
		width: 10rem;
		display: block;
	}
	.item4 .content::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}
	
	/*滚动条里面小方块*/
	.item4 .content::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(54, 68, 75, 1);
		background: rgba(54, 68, 75, 1);
	}
	
	/*滚动条里面轨道*/
	.item4 .content::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(54, 68, 75, 0.3);
		border-radius: 10px;
		background: rgba(54, 68, 75, 0.3);
	}
	
</style>
